import { LOGOUT_CART_CLEAR } from '@/store/mutation-types'
import LocalStore from '@/utils/localStore'
import Consts from '@/common/consts'

export default {
  state: {
    cartStoreList: LocalStore.get(Consts.CART_NAME, []), // 购物车本地数据
  },
  getters: {},
  mutations: {
    // 退出登录时,清空购物车
    [LOGOUT_CART_CLEAR]: state => {
      state.cartStoreList = [] // 清空 购物车本地Store
      LocalStore.set(Consts.CART_NAME, state.cartStoreList)
    },
  },
  actions: {},
}
